import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';

const HowToUsePage = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('howToUseSafaCards')}</h1>
        <p>{t('howToUseSafaCardsSubtitle')}</p>
      </header>

      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '800px', margin: '0 auto' }}>
        <section>
          <h2>{t('step1CreateAccount')}</h2>
          <p>{t('step1Description')}</p>
        </section>

        <section>
          <h2>{t('step2PickGroup')}</h2>
          <p>{t('step2Description')}</p>
        </section>

        <section>
          <h2>{t('step3LearnInContext')}</h2>
          <p>{t('step3Description')}</p>
        </section>

        <section>
          <h2>{t('step4PracticeAI')}</h2>
          <p>{t('step4Description')}</p>
        </section>

        <section>
          <h2>Spaced Repetition (SM-2) Tips</h2>
          <ul>
            <li>Create word groups of about 25 items for focused practice.</li>
            <li>Start with Learning Mode to get comfortable with new words.</li>
            <li>Then use Review All Words to engage SM‑2 across the whole group.</li>
            <li>Study daily; shorter, consistent sessions beat long cramming.</li>
          </ul>
          <p>
            Want the full guide? <Link to="/guide/sm2">Read the Spaced Repetition (SM‑2) guide</Link>.
          </p>
        </section>

        <section>
          <h2>{t('tryDemo')}</h2>
          <p>{t('tryDemoDescription')}</p>
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <Link to="/module/demo/group/0" className="btn btn-secondary">{t('viewDemoGroup')}</Link>
          </div>
        </section>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default HowToUsePage;
